export default "<img ng-src=\"{{$ctrl.icon_img}}\" style=\"height:20px;margin:{{$ctrl.margins}};\" />";